import React, { Component } from 'react'

import playerAvatar from "../../../../assets/img/demo/player-avatar-99.png";
import "../../../../assets/sass/pages/player-evaluation.scss";

import MainContent from './MainContent';

import { Form, Col, Button } from 'react-bootstrap';

import { ThemeContext } from '../../../layouts/ThemeProvider';
import SelectFilter from '../../../ui/select/SelectFilter';
import SelectSearch from '../../../ui/select/SelectSearch';
import FinishEvaluationModal from '../../../ui/modals/FinishEvaluationModal';
import PlayerBasicInformationCard from '../../../ui/cards/PlayerBasicInformationCard';
import AlertModal from '../../../ui/modals/AlertModal';
import Tools from "../../../../Tools";
import SA_SaveEvaluation from './components/SA_SaveEvaluation';
import SA_CancelEvaluation from './components/SA_CancelEvaluation';


class PlayerEvaluation extends Component {
    constructor(props) {

        super(props)

        Tools.redirectToErrorPage(props, ['scouting', 'my-scouting']);

        this.state = {
            showFinishEvaluationModal: false,
            showAlertModal: false,
        }

    }

    /**
     * Renders
     */

    render() {
        return (
            <div className="player-evaluation">
                {this.renderPlayerName()}
                {this.renderProfileHeader()}
                {this.renderFiltersBar()}
                {this.renderMainContent()}
                {this.renderModals()}
            </div>
        )
    }

    renderPlayerName = () => {
        const { playerName } = this.props;
        return (
            <div className="player-name">
                {playerName}
            </div>
        );
    };

    renderProfileHeader = () => {
        return (
            <PlayerEvaluation.Header
                avatar={playerAvatar}
                items={[
                    { title: "Playing Position", value: "CF, RAMF, RWF" },
                    { title: "Age", value: "24Yrs" },
                    { title: "Current Value", value: "$1M" },
                    { title: "Foot", value: "Left" },
                    { title: "Nationality", value: "Brazil" },
                    { title: "Passport", value: "Brazil" },
                    { title: "Curent Team", value: "Hardfoot FC" },
                    { title: "Contract Until", value: "01.31.2019" },
                    { title: "Int. Matches", value: "18" },
                    { title: "Int. Goals", value: "23" },
                    { title: "Total Matches", value: "89" },
                    { title: "Total Goals", value: "45" },
                    { title: "Manager/Agent", value: "Mark Henry" },
                ]}
            />
        );
    };

    renderFiltersBar = () => {
        const options = [
            { value: 'chocolate', label: 'All Competitions' },
            { value: 'strawberry', label: 'Strawberry' },
            { value: 'vanilla', label: 'Vanilla' },
        ];

        return (
            <div className="filters-bar">
                <Form onSubmit={this.handleSubmit} className="toolbar">
                    <Form.Row>
                        <div className="filters-container">
                            <SelectFilter type="sm" name="regions" placeholder="All Competitions" options={options} />
                            <SelectSearch type="sm" name="countries" placeholder="Against All Teams" searchPlaceholder="Search Conuntry" options={options} />
                            <SelectSearch type="sm" name="countries" placeholder="All Locations" searchPlaceholder="Search Conuntry" options={options} />
                        </div>
                        <div className="buttons-container">
                            <Button
                                className="sm"
                                variant="link"
                                onClick={() => this.handleCancelEvaluation()}
                            >Cancel Evaluation</Button>
                            <ThemeContext.Consumer>
                                {(theme) => (
                                    <Button
                                        className="sm"
                                        variant={theme === 'dark' ? "secondary" : "link"}
                                        onClick={() => this.handleSaveEvaluation()}
                                    >Save for Later</Button>
                                )}
                            </ThemeContext.Consumer>
                            <Button
                                className="sm"
                                variant="primary"
                                onClick={() => this.toggleFinishEvaluationModal(true)}
                            >Finish Evaluation</Button>
                        </div>
                    </Form.Row>
                </Form>
            </div>
        );
    };

    renderMainContent = () => {
        return (
            <PlayerEvaluation.MainContent />
        );
    }

    renderModals = () => {
        const { showFinishEvaluationModal, showAlertModal } = this.state;

        return (
            <>
                <FinishEvaluationModal
                    size="md"
                    show={showFinishEvaluationModal}
                    onHide={() => this.toggleFinishEvaluationModal(false)}
                    headerTitle="Generate report"
                    headerSubtitle="Select report template"
                    avgScore={86}
                    onInputChange={console.log}
                    onSuccess={() => this.toggleAlertModal(true)}
                />
                <AlertModal
                    size="sm"
                    show={showAlertModal}
                    className="mini-modal"
                    onHide={() => this.toggleAlertModal(false)}
                />
            </>
        )
    }

    /**
     * Handlers
     */

    toggleFinishEvaluationModal = (show) => {
        this.setState({
            showFinishEvaluationModal: show
        })
    }

    toggleAlertModal = (show) => {
        this.setState({
            showAlertModal: show
        })
    }

    handleCancelEvaluation = () => {
        new SA_CancelEvaluation().fire();
    }

    handleSaveEvaluation = () => {
        new SA_SaveEvaluation().fire();
    }

    static defaultProps = {
        // TODO: remove it
        playerName: "Eduardo Miles",
    };
}

PlayerEvaluation.Header = PlayerBasicInformationCard;
PlayerEvaluation.MainContent = MainContent;

export default PlayerEvaluation;